<div class="dah-cspace">
  <div class="mod_contact section">
    <div class="mod_contactcard" itemscope="" itemtype="http://schema.org/Organization">
      <div class="org" itemprop="name">{{tenant.content.contact.organisation}}</div>
      <div class="adr" itemprop="address" itemscope="" itemtype="http://schema.org/PostalAddress">
        <div class="street_address" itemprop="streetAddress">{{tenant.content.contact.street1}}</div>
        <div class="street_address" itemprop="streetAddress">{{tenant.content.contact.street2}}</div>
        <span class="postal_code" itemprop="postalCode">{{tenant.content.contact.postalCode}} </span><span class="locality" itemprop="addressLocality">{{tenant.content.contact.locality}}</span>
      </div>
      <div class="number"><span>Telefon</span>
        <span itemprop="telephone"> <a [href]="'tel:' + tenant.content.contact.phoneHref">{{tenant.content.contact.phone}}</a></span></div>
      <div class="po_box">
        <div class="po_box_label">{{tenant.content.contact.poBoxLabel}}</div>
        <div class="po_box_title">@for (line of tenant.content.contact.poBoxLines; track $index) {{{line}}@if (!$last) {<br>}}</div>
      </div>
    </div>
  </div>
</div>
